import * as SecurityGroupActions from '../state/security/security.action';
import app from '../app';

export default function SecurityGroupsService($q, $http, appSettings) {
  'ngInject';

  const groupsEndpoint = `${appSettings.IcebergApiUserInfoEndpoint}/groups`;
  const resourceUrl = `/${appSettings.IcebergApiEquipmentEndpoint.split('/')[3]}/equipment/`;
  const userUrl = `/${appSettings.IcebergApiUserInfoEndpoint.split('/')[3]}/users/`;

  this.getResourceUrl = function () {
    return resourceUrl;
  };

  this.getUserUrl = function () {
    return userUrl;
  };

  this.getAllSecurityGroups = function () {
    const endpoint = groupsEndpoint;
    return $http.get(endpoint);
  };

  this.postNewGroup = function (data) {
    const endPoint = groupsEndpoint;
    return $http.post(endPoint, data).then(this.UpdateSecurityGroups);
  };

  this.getSingleGroup = function (id) {
    const endPoint = `${groupsEndpoint}/${id}`;
    return $http.get(endPoint);
  };

  this.putGroupUpdate = function (id, data) {
    const endPoint = `${groupsEndpoint}/${id}`;
    return $http.put(endPoint, data).then(this.UpdateSecurityGroups);
  };

  this.patchEquipmentUserUpdate = function (id, data) {
    const deferred = $q.defer();

    const endPoint = `${groupsEndpoint}/${id}`;

    // 1. Patch the security group.
    $http.patch(endPoint, data).then(
      function (groupResponse) {
        // Super hack to get this out the door ASAP.
        // 2. On success, iterate changesets and patch equipment tags with group.
        for (let i = 0; i < data.length; i++) {
          let item = data[i];
          if (!!item.value.resource && item.value.resource.indexOf('equipment') > -1) {
            // Patch them shits.
            let tag = `onei3:security:group:${id}`;
            $http.patch(`${appSettings.BaseIcebergUrl}${item.value.resource}/tags`, {
              op: item.op,
              values: [tag],
            });
          }
        }

        // Return group patch response.
        deferred.resolve(groupResponse);
      },
      function (groupError) {
        // Group patch error.
        deferred.reject(groupError);
      },
    );

    return deferred.promise;
  };

  this.deleteGroup = function (id) {
    const endPoint = `${groupsEndpoint}/${id}`;
    return $http.delete(endPoint).then(this.UpdateSecurityGroups);
  };

  this.UpdateSecurityGroups = function (response) {
    app.getStore().dispatch(SecurityGroupActions.fetch());
    return response;
  };

  this.getSecurityGroupsByAttrs = (attrs) => {
    const attrsQueryString = Object.keys(attrs || {})
      .map((k) => `attr.${k}=${attrs[k]}`)
      .join('&');
    const endpoint = attrsQueryString ? `${groupsEndpoint}?${attrsQueryString}` : groupsEndpoint;
    return $http.get(endpoint).then((res) => res.data);
  };

  this.patchResources = (id, data) => {
    const endPoint = `${groupsEndpoint}/${id}`;
    return $http.patch(endPoint, data);
  };
}
